// extracted by mini-css-extract-plugin
module.exports = {"description":"Txs_description__2IPt5","tableContainer":"Txs_tableContainer__3O7OR"};